import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import { POS_ENABLED } from '../api/pos/config';
import { createPosEcho } from '../api/pos/realtime';

// Global Pusher tip tanımlaması
declare global {
    interface Window {
        Pusher: typeof Pusher;
    }
}

window.Pusher = Pusher;

const cloudEcho = new Echo({
    broadcaster: 'reverb',
    key: 'puoojs3smggtjetrykr7',
    wsHost: 'ws.rezmo.cloud',
    wsPort: 443,
    wssPort: 443,
    forceTLS: true,
    enabledTransports: ['ws', 'wss'],
    disableStats: true,
});

// POS rejimində `*.tables` kanallarını pos_local WS feed edir; qalan hər şey
// (QR, waiter-call, connector) toxunulmadan cloud echo-ya gedir. Cloud rejimində
// olduğu kimi qalır. Bax: api/pos/realtime.ts.
const echo = POS_ENABLED ? createPosEcho(cloudEcho) : cloudEcho;

export default echo;
